import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import EditarImagem from "../EditarImagem";
import InfoInput from "./InfoInput";
import ActionButton from "./ActionButton";

const CarteiraHeader = ({
  carteira,
  imagens,
  handleImageUpload,
  setImagem,
  save,
  handleInputChange,
  isLoading,
  periodoDeRenovacao,
  handleClick,
  copyDados,
  url,
}) => {
  const isSaveDisabled = save !== carteira.id;

  return (
    <div
      className="flex w-11/12 rounded-lg p-2 justify-around items-center m-4"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="max-w-36 max-h-48 rounded-2xl">
        <EditarImagem
          img={imagens[carteira.id]}
          handleImageUpload={handleImageUpload}
          setImagem={setImagem}
          imagemInicial={carteira.foto}
          carteiraId={carteira.id}
          save={save}
          isRecepcionada={carteira.status === "Recepcionada"}
        />
      </div>
      <div className="w-1/2 flex flex-col mx-2">
        <InfoInput
          placeholder="NOME"
          name="name"
          value={carteira.name.toUpperCase()}
          onChange={handleInputChange}
          id={carteira.id}
          disabled={isSaveDisabled}
        />
        <InfoInput
          placeholder="INSTIUIÇÃO DE ENSINO"
          name="instituicaoEnsino"
          value={carteira.instituicaoEnsino.toUpperCase()}
          onChange={handleInputChange}
          id={carteira.id}
          disabled={isSaveDisabled}
        />
        <InfoInput
          placeholder="CURSO"
          name="curso"
          value={carteira.curso.toUpperCase()}
          onChange={handleInputChange}
          id={carteira.id}
          disabled={isSaveDisabled}
        />
        <div className="flex w-full text-sm font-bold">
          <InfoInput
            label="CPF:"
            name="cpf"
            value={carteira.cpf}
            onChange={handleInputChange}
            id={carteira.id}
            disabled={isSaveDisabled}
          />
        </div>
        <div className="flex w-full text-sm font-bold">
          <InfoInput
            label="RG:"
            name="rg"
            value={carteira.rg}
            onChange={handleInputChange}
            id={carteira.id}
            disabled={isSaveDisabled}
          />
          <InfoInput
            label="DN:"
            name="dataNascimento"
            value={carteira.dataNascimento}
            onChange={handleInputChange}
            id={carteira.id}
            disabled={isSaveDisabled}
          />
        </div>
      </div>
      <div className="flex flex-col justify-center ml-2 w-1/5">
        {isLoading ? (
          <div className="loading">Renovando...</div>
        ) : (
          <>
            <h4 className="my-0.5 text-base">Status:</h4>
            <select
              id="status_carteira"
              name="status"
              value={carteira.status}
              onChange={(e) => handleInputChange(e, carteira.id)}
              disabled={carteira.status === "Expirada" ? true : false}
              className={`border-none rounded-md bg-white font-bold p-2 w-[100%] ${
                carteira.status === "Recepcionada"
                  ? "text-black"
                  : carteira.status === "Validada"
                  ? "text-green-500"
                  : carteira.status === "Cancelada"
                  ? "text-red-500"
                  : "text-black"
              }`}
            >
              <option style={{ color: "black" }} value="Recepcionada">
                Recepcionada
              </option>
              <option className="text-green-500" value="Validada">
                Validada
              </option>
              <option disabled value="Renovação">
                Renovação
              </option>
              <option disabled value="Expirada">
                Expirada
              </option>
              <option className="text-red-500" value="Cancelada">
                Cancelada
              </option>
            </select>
          </>
        )}
      </div>
      <div className="flex flex-col items-center w-1/5 ml-2">
        <div className="flex flex-col">
          <QRCodeCanvas
            className="qrCode"
            value={url + carteira.id}
            size={100}
            marginSize={1}
          />
          <span className="font-bold my-2.5"> {carteira.codigoUso}</span>
          <ActionButton
            isRenovacao={periodoDeRenovacao(carteira) === true || carteira.status === "Expirada"}
            isLoading={isLoading}
            handleClick={handleClick}
            copyDados={copyDados}
            carteira={carteira}
          />
        </div>
      </div>
    </div>
  );
};

export default CarteiraHeader;
